'use client';
import React from 'react';
import type { FormatTextProps } from '@/utils/text/text';
import { formatText } from '@/utils/text/text';

type RichTextListProps = {
    list?: FormatTextProps[];
};

export const RichTextList: React.FC<RichTextListProps> = ({ list = [] }) => {
    return (
        <ul>
            {list.map((element, index) => (
                // TODO: remove dangerouslySetInnerHTML
                <li key={index} dangerouslySetInnerHTML={{ __html: formatText(element) }} />
            ))}
        </ul>
    );
};
